import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { CalendarWeekItemStyled } from "./styled";
import { RENDER_BOOKING_STATUS } from "utils/functions/musicHall";

const CalendarWeekItem = ({ theme_standard, data, status, isHoliday }) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const renderStatus = RENDER_BOOKING_STATUS(
    data ? (status ? status : data[0]?.status) : null
  );
  return (
    <CalendarWeekItemStyled
      className={customClass}
      isHoliday={isHoliday}
      indicatorColor={isHoliday ? "#6e6e6e" : renderStatus.bgColor}
    >
      <div className="status_indicator" />
      <div className="cdw_list">
        {data &&
          data.length > 0 &&
          data.map((e, i) => (
            <div key={i} className="cdw_item">
              {e.booker_first_name}
              <div className="event_name_label">{e.event_name}</div>
            </div>
          ))}
      </div>
    </CalendarWeekItemStyled>
  );
};

CalendarWeekItem.propTypes = {};

export default CalendarWeekItem;
